<template>
    <div class="leave-index" >
        <!-- <myBreadCrumb :urls="JSON.stringify(breadcrumbs)" @createForm="dialog.state=true" :icon="icon"></myBreadCrumb> -->
        <create-dialog v-model="dialog" @CloseDialog="closeHandler" @fetchData="fetchData"></create-dialog>
        <v-card class="rounded-xl elevation-3">
            <v-card-title class="text-h6 font-weight-bold pt-4 pb-2 px-6">
                Phiếu điều chuyển
                <v-spacer></v-spacer> 
                
                <div class="d-flex align-center wrapper mx-1 my-1">
                    <v-btn @click="$emit('refresh')" outlined color="green lighten-3" class="rounded-lg" block style="width: 40px !important; height: 40px; padding: 0px;">
                    <v-icon color="green darken-4">mdi-refresh</v-icon></v-btn>
                </div>
                
                <v-divider vertical class="mx-4"></v-divider>

                <!-- <data-export v-model="exportDialog"></data-export> -->
                <v-btn @click="exportExcel" dark color="teal darken-4" class="rounded-pill elevation-3 mx-2 font-weight-bold px-6" style="text-transform: capitalize;"> <v-icon left>mdi-file-excel</v-icon> Xuất Excel </v-btn>
                <v-btn @click="dialog.state=true" dark color="teal darken-4" class="rounded-pill elevation-3 ml-2 font-weight-bold px-6"> <v-icon left>mdi-plus</v-icon> TẠO PHIẾU </v-btn>
            </v-card-title>
            
            <v-sheet class="grey lighten-4 py-6">
                <div class="d-flex flex-wrap mx-n2 px-4">
                    <div class="d-flex align-center wrapper mx-2 my-2">
                        <month-picker width="7rem" v-model="month" label="Tháng" outlined dense></month-picker>
                    </div>

                    <v-text-field label="Tìm kiếm" placeholder="Nhập mã hoặc tên NS" dense v-model="globalSearch" outlined hide-details persistent-placeholder
                        class="mx-2 my-2 flex-grow-1 flex-shrink-1" style="min-width: 250px; background-color: white;"></v-text-field>
                        
                    <v-checkbox label="Chuyển vùng" dense v-model="changeArea" @change="fetchData" hide-details class="mx-4 my-auto flex-shrink-1" color="green">
                        <template v-slot:label>
                            <span class="text-button" style="text-transform:none !important; margin-top:2px;">Chuyển vùng</span>
                        </template>
                    </v-checkbox>
                </div>
            </v-sheet>
            
            <v-sheet class="px-6 py-3 d-flex align-center grey lighten-5" style="border-top: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
                <div class="subtitle-2 font-weight-bold mr-4 text-uppercase grey--text text--darken-2">Thống kê:</div>
                <v-chip color="blue lighten-4" text-color="blue darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-file-document-outline</v-icon>
                    Tổng phiếu: <b class="ml-1">{{ totalCount }}</b>
                </v-chip>
                <v-chip color="orange lighten-4" text-color="orange darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-clock-outline</v-icon>
                    Chờ duyệt: <b class="ml-1">{{ pendingCount }}</b>
                </v-chip>
                <v-chip color="green lighten-4" text-color="green darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-check-circle-outline</v-icon>
                    Đã duyệt: <b class="ml-1">{{ confirmedCount }}</b>
                </v-chip>
                <v-chip color="red lighten-4" text-color="red darken-4" class="font-weight-medium" small>
                    <v-icon left small>mdi-close-circle-outline</v-icon>
                     Từ chối: <b class="ml-1">{{ rejectedCount }}</b>
                </v-chip>
            </v-sheet>
            
            <v-data-table height="calc(100vh - 350px)"
            fixed-header
            :search="globalSearch"
            :mobile-breakpoint="0"
            :headers="headers"
            :items="items"
            :loading="isLoading"
            loading-text="Đang tải dữ liệu..."
            >
                <template v-slot:[`item.employeeInfo`]="{item}">
                    <div class="subtitle-2 font-weight-bold" style="line-height: 1.2;">{{item.employeeName}}</div>
                    <div class="caption grey--text">{{item.employeeCode}}</div>
                </template>
                
                <template v-slot:[`item.toDepartmentName`]="{ item }">
                    <span class="text-caption"><v-icon small left>mdi-store</v-icon> {{ item.fromDepartmentName }}</span> <br>
                        <v-icon class="mr-2 my-1" small left color="grey">mdi-arrow-down</v-icon> <br>
                    <span class="text-caption font-weight-bold green--text text--darken-4">
                    <v-icon small color="green" left>mdi-home-city</v-icon>
                    {{ item.toDepartmentName }}</span> 
                </template>
                
                <template v-slot:[`item.type`]="{ item }">
                    <span class="font-weight-medium">{{ item.type }}</span> <br>
                    <span class="text-caption grey--text text--darken-1" v-if="item.note"><b class="green--text text--darken-4">Ghi chú: </b>{{ item.note }}</span>
                    <div v-if="item.attachmentUrl" class="mt-1">
                        <v-btn x-small depressed rounded color="red lighten-5" :href="item.attachmentUrl" target="_blank" class="red--text text--darken-4 font-weight-bold" style="text-transform: none;">
                            <v-icon left x-small>mdi-file-pdf-box</v-icon> Xem đính kèm
                        </v-btn>
                    </div>
                </template>
                
                <template v-slot:[`item.validFrom`]="{ item }">
                    <div style="line-height: 1.3;"><v-icon small color="orange" left>mdi-calendar</v-icon> {{ formatDate(item.validFrom) }}</div>
                </template>

                <template v-slot:[`item.confirm1`]="{item}">
                    <div v-if="item.confirmBy1Code" style="line-height: 1.3;" class="py-1">
                        <div class="subtitle-2 font-weight-bold" style="line-height: 1.2;">{{item.confirmBy1Name}}</div>
                        <div class="caption grey--text mb-1">{{item.confirmBy1Code}}</div>
                        <v-chip v-if="item.status1 !== null && item.status1 !== undefined" :color="$helper.formatStatus(item.status1).color" x-small dark class="px-2">{{ $helper.formatStatus(item.status1).text }}</v-chip>
                        <div v-if="item.status1 !== 0 && item.confirmedAt1 && item.confirmedAt1 !== '01/01/0001'" class="caption grey--text mt-1"><v-icon x-small disabled pb-1>mdi-clock-outline</v-icon> {{item.confirmedAt1}}</div>
                    </div>
                </template>

                <template v-slot:[`item.confirm2`]="{item}">
                    <div v-if="item.confirmBy2Code" style="line-height: 1.3;" class="py-1">
                        <div class="subtitle-2 font-weight-bold" style="line-height: 1.2;">{{item.confirmBy2Name}}</div>
                        <div class="caption grey--text mb-1">{{item.confirmBy2Code}}</div>
                        <v-chip v-if="item.status2 !== null && item.status2 !== undefined" :color="$helper.formatStatus(item.status2).color" x-small dark class="px-2">{{ $helper.formatStatus(item.status2).text }}</v-chip>
                        <div v-if="item.status2 !== 0 && item.confirmedAt2 && item.confirmedAt2 !== '01/01/0001'" class="caption grey--text mt-1"><v-icon x-small disabled pb-1>mdi-clock-outline</v-icon> {{item.confirmedAt2}}</div>
                    </div>
                </template>

                <template v-slot:[`item.processInfo`]="{item}">
                    <div style="line-height: 1.3;"><span class="grey--text caption">Gửi:</span> {{item.senderName}}</div>
                    <div style="line-height: 1.3;" v-if="item.createdAt != '01/01/0001'"><span class="grey--text caption">Lúc:</span> {{ formatDateTime(item.createdAt) }}</div>
                </template>

                <template v-slot:[`item.acceptedAt`]="{item}">
                    <div v-if="item.acceptedAt != '01/01/0001' && item.status != 0" style="line-height: 1.3;">{{ formatDateTime(item.acceptedAt) }}</div>
                </template>

                <template v-slot:[`item.status`]="{ item }">
                    <v-chip :color="$helper.formatStatus(item.status).color" small dark style="width: 100px; justify-content: center;">
                        <span class="font-weight-bold">{{ $helper.formatStatus(item.status).text }}</span>
                    </v-chip>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                    <v-btn x-small depressed rounded v-if="item.status == 0 && !isLoading" class="mx-1 my-1 green--text text--darken-3 font-weight-bold" color="green lighten-4" @click="changeItemStatus(item.id, 1)">
                        <v-icon left small>mdi-check-circle</v-icon> Duyệt
                    </v-btn>

                    <v-btn x-small depressed rounded v-if="item.status == 0 && !isLoading" class="mx-1 my-1 red--text text--darken-3 font-weight-bold" color="red lighten-4" @click="changeItemStatus(item.id, 2)">
                        <v-icon left small>mdi-close-circle</v-icon> Từ chối
                    </v-btn>

                    <v-btn x-small depressed rounded class="mx-1 my-1 blue-grey--text text--darken-3 font-weight-bold" v-if="item.status != 0" color="blue-grey lighten-4" @click="changeItemStatus(item.id, 0)">
                        <v-icon left small>mdi-undo</v-icon> Hoàn tác
                    </v-btn>
                    
                    <v-btn x-small depressed rounded class="mx-1 my-1 red--text text--darken-2 font-weight-bold" color="grey lighten-4" @click="deleteItem(item)" v-if="!item.isLock">
                        <v-icon left small>mdi-delete</v-icon> Xóa
                    </v-btn>
                    
                    <v-icon small color="grey" v-else>mdi-lock</v-icon>
                </template>
            </v-data-table>
        </v-card>
        <!-- <v-card v-if="true" class="mt-5">
        </v-card> -->
        <!-- ************** DELETE CONFIRMATION *************** -->
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="headline">Bạn có chắc muốn xoá dữ liệu này?</v-card-title>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialogDelete=false">Thoát</v-btn>
                <v-btn color="blue darken-1" text @click="cfmDeleteItem">OK</v-btn>
                <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import * as moment from "moment/moment";
import CreateButton from '@/components/Crud/CreateButton';
import http from '@/components/services/http-common';
import Create from '@/views/Request/EmployeeRotation/Create.vue';
import DataFilter from '@/components/DataFilter.vue';

export default {
    name: 'Leave',
    components: {
        CreateButton,
        "create-dialog": Create,
        "data-filter": DataFilter
    },
    watch: {
        tableParams: {
            handler (val) {
                this.fetchData();
                this.fetchCity();
            },
            deep: true,
        },
        filters: {
            handler (val) {
                this.tableParams.page=1;
                this.fetchData();
            },
            deep: true,
        },
        month: {
            handler(val)
            {
                this.filters.from = moment(val, "YYYY-MM").startOf("month").format("YYYY-MM-DD");
                this.filters.to = moment(val, "YYYY-MM").endOf("month").format("YYYY-MM-DD");
            }
        }
    },

    computed: {
        webAllowed() {
            let user = localStorage.getItem("user");
            let webAllowed = localStorage.getItem("WebAllowed");
            user = JSON.parse(user);
            return webAllowed.includes(user.employeeCode);
        },
        params: function() {
            return {...this.tableParams, ...this.filters}
        },
        pendingCount() {
            return this.items.filter((item) => item.status === 0).length;
        },
        confirmedCount() {
            return this.items.filter((item) => item.status === 1).length;
        },
        rejectedCount() {
            return this.items.filter((item) => item.status === 2).length;
        },
        totalCount() {
            return this.items.length;
        }
    },
    data() {
        return {
            ROOT_URL: "EmployeeRotationRequests/",

            //HEADER DATA
            icon:{
                icon: "mdi-plus-thick",
                to: ""
            },

            //filters
            month: moment().format("YYYY-MM"),
            isFocused: false,
            changeArea: false,
            globalSearch:"",
            filters:{
                code:null,
                employeeName:null,
                from: moment().startOf("month").format("YYYY-MM-DD"),
                to: moment().endOf("month").format("YYYY-MM-DD"),
            },
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
            },
            rowCount: 0,

            //TABLE
            headers: [
                { text: 'Thao tác', value: 'actions', width: '9rem'},
                { text: 'Mã', value: 'id', width: '5rem' },
                { text: '', align: ' d-none', value: 'employeeCode', sortable: true, width: '7rem' },
                { text: '', align: ' d-none', value: 'employeeName', sortable: true, width: '7rem' },
                { text: 'Trạng thái', align: 'start', value: 'status', sortable: true, width: '7rem' },
                { text: 'Nhân viên', align: 'start', value: 'employeeInfo', width: '11rem'},
                { text: 'Điều chuyển', value: 'toDepartmentName', width: '16rem'},
                { text: 'Bắt đầu từ', value: 'validFrom', width: '7rem'},
                { text: 'Loại', value: 'type', width: '13rem'},
                { text: 'Quản lý 1', align: 'start', value: 'confirm1', width: '11rem'},
                { text: 'Quản lý 2', align: 'start', value: 'confirm2', width: '11rem'},
                { text: 'Trạng thái xử lý', align: 'start', value: 'processInfo', width: '9rem'},
                { text: 'Ngày duyệt', align: 'start', value: 'acceptedAt', width: '8rem'},
            ],

            items: [],
            options: {},
            isLoading: true,

            //DIALOG
            dialog: {
                state: false,
                item: undefined,
            },
            dialogDelete: false,
            targetItem: {},

        }
    },

    methods: {
        
        colorClass(value) {
            switch (value) {
            case 0: return "blue darken-2"
            case 1: return "green darken-2"
            case 2: return "red darken-2"
            default: return ""
            }
        },
        formatDate(value) {
            return moment(value).format("DD/MM/YYYY");
        },
        formatDateTime(value) {
            return moment(value).format("DD/MM/YYYY HH:mm:ss");
        },
        
        status(value) {
            let result = {};
            switch(value) {
                case 0: {
                    result.text = "Chờ duyệt";
                    result.color = "warning"
                    break;
                }
                case 1: {
                    result.text = "Đã duyệt"
                    result.color = "success"
                    break;
                }
                case 2: {
                    result.text = "Từ chối"
                    result.color = "error"
                    break;
                }
                default:{
                    result.text = "unknown"
                    break;
                }
            }
            return result;
        },

        //DATA JS
        fetchData () {
            return http.get(`${this.ROOT_URL}hr`, {
                params: {
                    month: this.month,
                    changeArea: this.changeArea
                }
            })
            .then(res => {
                this.items = res.data;
                this.rowCount = res.data;
                this.isLoading = false;
            })
        },
        exportExcel(){
            return http.get(this.ROOT_URL+"hr/export", {
                params: {
                    month: moment(this.month).format('YYYY-MM-DD')
                },
                responseType: 'blob',
            }).then(res => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `DANH SACH_PHIEU_HT_${moment(this.month, 'yyyy-MM-dd').format("MM-YYYY")}.xlsx`);
                document.body.appendChild(link);
                link.click();
            });
        },

        changeItemStatus(id, status){
            return http.get(`${this.ROOT_URL}hr/change-status`, {
                params: {
                    id: id,
                    status: status
                }
            })
            .finally(()=> {this.fetchData()})
        },

        //DIALOG METHOD
        openDialog() {
            this.params = {
            }
        },
        closeHandler () {
            this.dialog = {state: false, item: undefined}
        },
        editItem (item) {
            this.dialog = {state: true, item: item}
        },
        deleteItem (item) {
            this.dialogDelete = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            http.delete(this.ROOT_URL + "undo/" +this.targetItem.id).then(res => {
                this.fetchData();
                this.dialogDelete = false;
            }).catch(err => {
                switch (err.response.status)
                {
                    case 403:{
                        this.unauthorizeAlert();
                        this.dialogDelete = false;
                        break;
                    }
                    default:
                        break;
                }
            })
        },

    },
    
    created() {
        this.fetchData();
    }
}
</script>